// utilities
import api from '@/utilities/api'

// open
export const getCommercialPermits = ({ rootState, commit, dispatch }, payload) => {
  return api.request({
    method: 'get',
    endpoint: 'private/commercialPermits',
    success (response) {
      commit('setCommercialPermits', response.data)
    }
  })
}

export const createCommercialPermit = ({ commit, dispatch }, payload) => {
  // convert dates
  return api.request({
    method: 'post',
    endpoint: 'private/commercialPermits',
    payload,
    success (response) {
      dispatch('getCommercialPermits')
    }
  })
}

export const updateCommercialPermit = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'put',
    endpoint: `private/commercialPermits/${payload.commercialPermitID}`,
    payload,
    success (response) {
      dispatch('getCommercialPermits')
    }
  })
}

export const deleteCommercialPermit = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'delete',
    endpoint: `private/commercialPermits/${payload.commercialPermitID}`,
    payload,
    success (response) {
      dispatch('getCommercialPermits')
    }
  })
}

export const getPeopleByCommercialPermit = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'get',
    endpoint: `private/commercialPermits/${payload.commercialPermitID}/people`,
    payload,
    success (response) {
      console.log(response.data)
      commit('setPeopleByCommercialPermit', response.data)
    }
  })
}
